import { createFileRoute } from "@tanstack/react-router"
import { RoleList } from "@/components/rema/roles"

function RolesPage() {
  return (
    <div className="p-6">
      <RoleList />
    </div>
  )
}

export const Route = createFileRoute("/rema/roles/")({
  staticData: {
    title: 'Manage Roles',
    isSecured: true,
  },
  component: RolesPage,
})
